/* eslint-disable no-param-reassign */
import produce from 'immer';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const createPageSlice = (set) => ({
  selectedReturnMethod: 1,
  selectedLocker: null,
  isProcessingOrder: false,
  disableHeader: false,
  setSelectedReturnMethod: (selectedReturnMethod) => {
    set(
      produce((draft) => {
        draft.selectedReturnMethod = selectedReturnMethod;
      }),
    );
  },
  setSelectedLocker: (selectedLocker) => {
    set(
      produce((draft) => {
        draft.selectedLocker = selectedLocker;
      }),
    );
  },
  setIsProcessingOrder: (isProcessingOrder) => {
    set(
      produce((draft) => {
        draft.isProcessingOrder = isProcessingOrder;
      }),
    );
  },
  setDisableHeader: (disableHeader) => {
    set(
      produce((draft) => {
        draft.disableHeader = disableHeader;
      }),
    );
  },
});

const usePageStore = create(
  devtools(
    (...a) => ({
      ...createPageSlice(...a),
    }),
    { name: 'PublicSelectReturnMethodPageStore' },
  ),
);

export default usePageStore;
